module.exports = __webpack_public_path__ + "img/from_toeic_content.cd34f608.svg";